import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CalendarComponent } from './calendar.component';
import { PadstartPipe } from './padstart.pipe';
import { GetSimpleDatePipe } from './get-simple-date.pipe';
import { GetDayInDataPipe } from './get-day-in-data.pipe';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { TooltipModule } from '@finder/shared/components/tooltip/tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        FontIconModule,
        TooltipModule
    ],
    declarations: [
        CalendarComponent,
        PadstartPipe,
        GetSimpleDatePipe,
        GetDayInDataPipe,
    ],
    providers: [
        GetDayInDataPipe,
        GetSimpleDatePipe,
    ],
    exports: [
        CalendarComponent,
    ],
})
export class CalendarModule {}
